var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5493 3.54124C26.5314 3.99149 25.4519 4.2872 24.3467 4.41857C25.5117 3.72181 26.3836 2.62525 26.8 1.33324C25.7067 1.9839 24.508 2.4399 23.2587 2.68657C22.4195 1.78867 21.3071 1.19319 20.0946 0.992682C18.8821 0.792177 17.6373 0.99789 16.5537 1.57784C15.4701 2.15779 14.6085 3.07948 14.1028 4.19963C13.5971 5.31977 13.4757 6.57561 13.7573 7.7719C11.5401 7.66078 9.37111 7.0846 7.39105 6.08079C5.41099 5.07698 3.66417 3.66797 2.264 1.94524C1.76839 2.7965 1.50794 3.7642 1.50933 4.74924C1.50933 6.68257 2.49333 8.39057 3.98933 9.39057C3.10401 9.3627 2.23818 9.12361 1.464 8.69324V8.76257C1.46427 10.0502 1.90983 11.2981 2.72513 12.2947C3.54043 13.2912 4.67531 13.9752 5.93733 14.2306C5.11549 14.4533 4.25374 14.4861 3.41733 14.3266C3.77316 15.4349 4.46668 16.4042 5.40079 17.0987C6.3349 17.7933 7.46284 18.1783 8.62667 18.1999C7.46997 19.1083 6.14557 19.7799 4.72917 20.1761C3.31278 20.5724 1.83217 20.6856 0.372 20.5092C2.92093 22.1485 5.88813 23.0187 8.91867 23.0159C19.176 23.0159 24.7853 14.5186 24.7853 7.14924C24.7853 6.90924 24.7787 6.66657 24.768 6.42924C25.8598 5.64013 26.8021 4.6626 27.5507 3.54257L27.5493 3.54124Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.34942dac17eb4072941349ada7093947.svg";
export { ForwardRef as ReactComponent };